module.exports = "<div ncy-breadcrumb></div> <h1>{{vm.brand.name}}</h1> <product-overview context=brand-detail model=vm.productOverviewModel parent-state=vm.parentState></product-overview>";


//////////////////
// WEBPACK FOOTER
// ./features/brand/detail.html
// module id = 566
// module chunks = 0